import {createStore, applyMiddleware} from 'redux';
// import thunkMiddleware from 'redux-thunk';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers';
import {createLogger} from 'redux-logger';

// const loggerMiddleware = createLogger();
// let nodeENV = process?.env?.REACT_APP_NODE_ENV;
const nodeENV = (typeof process !== 'undefined' && process.env.REACT_APP_NODE_ENV) || 'development';

let middleware = [
    thunk,
];

if (nodeENV !== 'production') {
    middleware = [...middleware];
    // middleware = [...middleware, loggerMiddleware];
}

const composeEnhancers = applyMiddleware(...middleware);

export const store = createStore(
    rootReducer,
    composeEnhancers
);